export default "__VITE_ASSET__CBchMd$R__"